import React from 'react'
import { GatsbyImage } from "gatsby-plugin-image";
import * as styles from './index.module.css'
import { GradientBorder } from '../commons'
import Button from '../Button/'

const CareerPros = ({ components }) => {
  return (
    <div className="wrapper">
      <div className={styles.container}>
        {components.map((comp, idx) => (
          <div className={styles.section} key={idx}>
            <GradientBorder height="1px" className={styles.grad} />
            <h2 className={styles.title}>{comp.title}</h2>
            <div className={styles.subtitle}>
              {comp.subtitle.subtitle.split('\n').map((desc, idx) => (
                <div className={styles.desc} key={idx}>
                  {desc}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default CareerPros
